import React from 'react';
import { User, Lock } from 'lucide-react';
import { useAuthStore } from '../stores/authStore';
import { Link } from 'react-router-dom';

const Account = () => {
  const { user } = useAuthStore();

  return (
    <div className="max-w-4xl mx-auto">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900 flex items-center" data-testid="account-heading">
          <User className="mr-3" />
          Account
        </h1>
        <p className="text-gray-600 mt-1">
          Manage your account settings and authentication methods
        </p>
      </div>

      {/* Password Management */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
        <div className="px-6 py-5 border-b border-gray-200 flex items-center justify-between">
          <div className="flex items-center">
            <div className="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center mr-3">
              <Lock className="h-5 w-5 text-blue-600" />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-gray-900">Password</h2>
              <p className="text-sm text-gray-600">
                {user?.hasPassword 
                  ? 'Change your account password for enhanced security.'
                  : 'Add a password so you can sign in without re-confirming your email every time.'
                }
              </p>
            </div>
          </div>
          <Link
            to={user?.hasPassword ? "/account/change-password" : "/settings/password"}
            data-testid={user?.hasPassword ? "change-password-link" : "set-password-link"}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            {user?.hasPassword ? 'Change Password' : 'Set Password'}
          </Link>
        </div>
        <div className="px-6 py-4 bg-blue-50 border-t border-blue-100 text-sm text-blue-700">
          <p>
            {user?.hasPassword 
              ? 'You can log in with email and password or continue using your connected providers.'
              : 'Once your password is saved you can choose to log in with email and password or continue using your connected providers.'
            }
          </p>
        </div>
      </div>

      {/* Account Information */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="px-6 py-5 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900 flex items-center">
            <User className="mr-2 h-5 w-5" />
            Account Information
          </h2>
        </div>
        <div className="px-6 py-4">
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Email
              </label>
              <p className="text-sm text-gray-900">{user?.email}</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Account Type
              </label>
              <p className="text-sm text-gray-900">
                {user?.isTemporary ? 'Email verified' : 'Full account'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Account;
